import { useFocusMode } from "@/hooks/use-focus-mode";
import { Focus, FocusIcon } from "lucide-react";

/** Small floating pill to enter Focus Mode. Hides nav/footer, enlarges type. */
export function FocusToggle() {
  const [on, toggle] = useFocusMode();
  return (
    <button
      type="button"
      onClick={() => toggle()}
      aria-pressed={on}
      aria-label={on ? "Exit focus mode" : "Enter focus mode"}
      className="fixed bottom-24 right-4 z-40 inline-flex items-center gap-2 rounded-full border hairline bg-charcoal/80 px-3 py-2 text-[10px] uppercase tracking-[0.25em] text-gold backdrop-blur-md transition-colors hover:border-gold hover:text-gold-luminous focus:outline-none focus:ring-2 focus:ring-gold sm:bottom-6"
    >
      {on ? <FocusIcon size={12} aria-hidden /> : <Focus size={12} aria-hidden />}
      {on ? "Focus On" : "Focus"}
    </button>
  );
}
